// mds-dojo — dojo/json (native JSON passthrough; dojo used native when present).

export function parse(str: string, _strict?: boolean): any {
  return JSON.parse(str);
}

export function stringify(value: any, replacer?: any, spacer?: any): string {
  return JSON.stringify(value, replacer, spacer);
}

const json = { parse, stringify };
export default json;
